import { render } from "./Exchange.vue?vue&type=template&id=796777d1"
import script from "./Exchange.vue?vue&type=script&lang=js"
export * from "./Exchange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/shop/Exchange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "796777d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('796777d1', __exports__)) {
    api.reload('796777d1', __exports__)
  }
  
  module.hot.accept("./Exchange.vue?vue&type=template&id=796777d1", () => {
    api.rerender('796777d1', render)
  })

}


export default __exports__